export default __webpack_public_path__ + "static/media/Maria_Lopez.ea973426.png";